import { FC } from 'react';
import cx from 'classnames';
import { CatIconMachineExcavator } from '@blocks-react/components/Icons/MachineExcavator';
import { CatIconMachineTractor } from '@blocks-react/components/Icons/MachineTractor';
import styles from './HeaderEquipmentIcon.module.scss';

export const HeaderEquipmentIcon: FC<{
  isFeatureFlag: boolean;
}> = ({ isFeatureFlag }) => (
  <div className={cx(styles['header-equipment-icon'])}>
    {isFeatureFlag ? (
      <CatIconMachineTractor
        className={cx(styles['header-equipment-icon--size'])}
      />
    ) : (
      <CatIconMachineExcavator
        className={cx(styles['header-equipment-icon--size'])}
      />
    )}
  </div>
);
